export * from './dist/document.js'